import React from 'react'
import ReactDOM from 'react-dom'
import BaseInputComponent from './BaseInputComponent'
import Immutable from 'immutable'
import { t } from '../../helpers/translate.js'
import { Input } from 'react-bootstrap'
import StaticTextComponent from './StaticTextComponent'
import { request } from '../../helpers/request'
import { checkOrg } from '../../helpers/access.js'
let config = require('config');

class CheckboxComponent extends BaseInputComponent {

  constructor(props) {
    super(props);

    this.state = {
      filterOptions: ''
    };
  }

  fetchData(url) {
    request(`${config.default.api}/${this.props.optionsUrl}`, 'GET', null, this.getOptionsFromUrl.bind(this));
    return [];
  }

  getOptionsFromUrl(responseData, statusCode) {
    if (statusCode == 200) {
      this.props.updateOptions(this.props.savedOptionsState, responseData)
    }
  }

  getOptions() {
    let savedOptions = this.props.getSavedOptions(this.props.savedOptionsState)
    return savedOptions ? savedOptions : this.fetchData(this.props.optionsUrl);
  }

  searchOptions(value) {
    this.setState({ filterOptions: value });
  }

  showTextFilter() {
    return this.props.showFilter && <Input
      id={this.props.id}
      type='text'
      placeholder='Search...'
      defaultValue={this.state.filterOptions || ''}
      onChange={(event) => { this.searchOptions(event.target.value) }}
    />
  }

  render() {
    const value = this.getValue();
    const showFilter = this.props.showFilter;
    let tt = [];
    const options = this.props.optionsUrl ? this.getOptions() : this.props.options;

    if (value !== undefined) {
      tt = value.toJS();
    }

    if (this.props.isStatic && showFilter) {
      let text = '';

      for (let option of options) {
        if (option.value == t(value)) {
          text = t(option.text);
        }
      }
      return <StaticTextComponent id={this.props.id} value={text} />
    }

    const multiDiv = showFilter && 'multiselect-line';
    const multiLabel = showFilter && 'multiselect-label';
    const mainDivClass = showFilter && 'multiselect-div';

    return <div className={`${mainDivClass}`}>
      {(showFilter && checkOrg('ingle')) && <p>** {t('Please include Primary School Code to All School Codes List')} **</p>}
      {this.showTextFilter()}
      {options.map((option) => {
        if (option.text && option.text.toLowerCase().includes(this.state.filterOptions.toLowerCase())) {
          return <div className={`form-group ${multiDiv} ${this.state.isInvalid ? 'has-error' : ''}`}>
            <label className={`form-control-static ${multiLabel}`}>
              <input id={this.props.id}
                disabled={this.props.isStatic}
                onChange={(event) => { this.updateCheckboxes(option.value, event.target.checked) }}
                type="checkbox"
                checked={tt.includes(option.value)} />
              {t(option.text)}
            </label>
          </div>
        }
      })}
    </div>
  }

  updateCheckboxes(val, value) {

    let rr = []

    if (this.getValue() !== undefined) {
      rr = this.getValue().toJS()
    }

    if (value) {
      rr.push(val)
    } else {
      rr = rr.filter(num => num != val)
    }

    this.handleChange(Immutable.fromJS(rr))
  }
}

export default CheckboxComponent;



// WEBPACK FOOTER //
// ./src/components/common/CheckboxGroupComponent.js